export
const name: string = "Grass";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute vec3  a_normal;
    attribute vec2  a_texcoords;
    attribute float a_manipulation;
    attribute vec3  a_offset;
    attribute vec2  a_random;

    uniform mat4    u_view_projection;
    uniform mat4    u_modelMatrix;
    uniform mat4    u_heightMatrix;
    uniform mat4    u_manipulator;

    uniform vec2    u_textureScale;
    uniform float   u_time;
    uniform vec3    u_lightDirection;
`;

export
const varyings: string = `
    varying vec2    v_random;
    varying vec2    v_texcoords;
    varying vec4    v_relativePosition;
`;

export
const implementation: string = `
    void main()
    {
        // a_normal ... when a_normal doesn't exists, it will not render textures on model, why?
        // a_normal.y is approximately 0.7
        float scale = a_random[0] * 1.0 + a_normal.y;   // 0.7 - 1.7
        vec3 scaledPosition = a_position * scale;
        vec3 inPosition = scaledPosition + a_offset;

        // Waving
        float diff = sin((u_time + a_random[0]) * 5.0) * scaledPosition.y * 0.25;
        inPosition.z += diff;
        inPosition.x += diff;

        // Scaling of the texture
        v_texcoords = a_texcoords;
        v_random = a_random;

        // Coordinates
        vec4 position = vec4(inPosition, 1.0);
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * u_modelMatrix * position;
        }
    #endif

        vec4 clipSpacePosition = u_view_projection * position;
        gl_Position = clipSpacePosition;

        // This coordinates are for second MVP matrix because of the grass cut off when it is above model geometry
        v_relativePosition = u_heightMatrix * position;

    #ifdef LOGDEPTH
        setVaryingsForLogarithmicDepthBuffer();
    #endif

       setVaryingsForLighting2(u_lightDirection, position, clipSpacePosition);

    #ifdef CLIPPING_PLANE
       setVaryingsForCPlane(position);
    #endif
    }
`;
